import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

/* ========= Filter Button ========= */
export const FilterBtn = styled.button`
  position: relative;
  height: 36px;
  padding: 0 14px 0 36px;

  border-radius: 10px;
  border: 1px solid #e2e8f0;

  background: linear-gradient(180deg, #ffffff, #f8fafc);
  color: #0f172a;

  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.01em;

  cursor: pointer;

  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);
  transition: all 0.18s ease;

  display: inline-flex;
  align-items: center;
  gap: 6px;

  &::before {
    content: "⚙️";
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    opacity: 0.75;
  }

  &:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(15, 23, 42, 0.08);
  }

  &:active {
    transform: scale(0.97);
    background: #e2e8f0;
  }
`;

/* ========= Popover ========= */
export const Popover = styled.div`
  position: fixed;
  transform: translateX(-50%);
  z-index: 999999;

  width: 220px;
  padding: 12px 12px 10px 12px;

  border-radius: 14px;
  background: #ffffff;
  border: 1px solid #e2e8f0;

  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.12),
    0 6px 14px rgba(15, 23, 42, 0.08);

  display: flex;
  flex-direction: column;
  gap: 8px;

  animation: popIn 0.18s ease-out;

  @keyframes popIn {
    from {
      opacity: 0;
      transform: translate(-50%, -6px) scale(0.97);
    }
    to {
      opacity: 1;
      transform: translate(-50%, 0) scale(1);
    }
  }
`;

/* Header */
export const PopoverHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 2px 2px 6px 2px;

  span:first-child {
    font-size: 13px;
    font-weight: 700;
    color: #0f172a;
  }

  .summary {
    font-size: 11px;
    color: #64748b;
  }

  border-bottom: 1px dashed #e2e8f0;
`;

/* Body */
export const PopoverBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px 2px 4px 2px;
  max-height: 220px;
  overflow-y: auto;

  .empty {
    font-size: 12px;
    color: #94a3b8;
    padding: 6px 4px;
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 999px;
  }
`;

/* Tag Item */
interface TagItemProps {
  active?: boolean;
}

export const TagItem = styled.div<TagItemProps>`
  padding: 8px 9px;
  border-radius: 8px;

  display: flex;
  align-items: center;
  gap: 8px;

  cursor: pointer;

  font-size: 12px;
  font-weight: 600;

  background: ${({ active }) =>
    active ? "rgba(37, 99, 235, 0.12)" : "#f8fafc"};
  color: ${({ active }) => (active ? "#1d4ed8" : "#475569")};
  border: 1px solid ${({ active }) => (active ? "#bfdbfe" : "transparent")};

  transition: all 0.14s ease;

  position: relative;
  padding-left: 28px;

  &::before {
    content: ${({ active }) => (active ? "'✓'" : "''")};
    position: absolute;
    left: 9px;
    top: 50%;
    transform: translateY(-50%);
    width: 14px;
    height: 14px;
    border-radius: 999px;

    font-size: 11px;
    line-height: 14px;
    text-align: center;
    font-weight: 700;

    background: ${({ active }) => (active ? "#1d4ed8" : "transparent")};
    color: #ffffff;

    box-shadow: ${({ active }) => (active ? "0 0 0 1px #bfdbfe" : "none")};
    opacity: ${({ active }) => (active ? 1 : 0)};
    transition: all 0.14s ease;
  }

  &:hover {
    background: ${({ active }) => (active ? "#dbeafe" : "#e5edf7")};
    transform: translateY(-1px);
  }
`;

export const Footer = styled.div`
  padding: 8px 12px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
`;

export const ApplyButton = styled.button`
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #111827;
  cursor: pointer;

  &:hover {
    background: #f3f4f6;
  }
`;
